"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const currency_js_1 = __importDefault(require("currency.js"));
const blockedOccupations_1 = __importDefault(require("../commonApp/blockedOccupations"));
function filtersGroq(userProfile, filtersField = 'adPacingFilters') {
    var _a, _b, _c, _d, _e;
    if (!userProfile)
        return '';
    const workingRemote = userProfile.workingRemote ? `(
  ${filtersField}.requiredRemoteStatuses == null
    || length(${filtersField}.requiredRemoteStatuses) == 0
    || "${userProfile.workingRemote}" in ${filtersField}.requiredRemoteStatuses
  )` : null;
    const personalIncome = ((_a = userProfile.employment) === null || _a === void 0 ? void 0 : _a.income) ? `(
  ${filtersField}.minimumEmploymentIncome == null
    || ${(0, currency_js_1.default)(userProfile.employment.income).value} > ${filtersField}.minimumEmploymentIncome
  )` : null;
    const householdIncome = ((_b = userProfile.household) === null || _b === void 0 ? void 0 : _b.income) ? `(
  ${filtersField}.minimumHouseholdIncome == null
    || ${(0, currency_js_1.default)(userProfile.household.income).value} > ${filtersField}.minimumHouseholdIncome
  )` : null;
    const state = ((_c = userProfile.personalInfo) === null || _c === void 0 ? void 0 : _c.state) ? `(
  ${filtersField}.disallowedStates == null
    || length(${filtersField}.disallowedStates) == 0
    || !("${userProfile.personalInfo.state.toUpperCase()}" in ${filtersField}.disallowedStates)
  )` : null;
    const allowBlocked = (((_d = userProfile.professionClassifier) === null || _d === void 0 ? void 0 : _d.professionId)
        && blockedOccupations_1.default.includes((_e = userProfile === null || userProfile === void 0 ? void 0 : userProfile.professionClassifier) === null || _e === void 0 ? void 0 : _e.professionId)) ? `(
    ${filtersField}.allowBlockedOccupations == null
    || ${filtersField}.allowBlockedOccupations
  )` : null;
    return [
        workingRemote,
        personalIncome,
        householdIncome,
        state,
        allowBlocked,
    ].filter((v) => Boolean(v)).join(' && ');
}
exports.default = filtersGroq;
